import {
  CHECK_ONBOARDING,
  startOnboarding,
  START_MULTI_PAGE_TOUR,
  END_TOUR,
  SKIP_TOUR,
  startTour
} from './onboardingActions';
import { logEvent, ONBOARDING, START } from 'lib/analytics';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getAuth } from 'actions/auth/login';
import { getVisits, markAsVisited } from 'api/visits';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';
import {
  hasAnalyticsPermission,
  hasAccountsUsersAndGroupsPermission
} from 'actions/auth/login';
import { tourName as CompletedTour } from './config/completedTour';
import { tourName as AccountsGroupsTour } from './config/accountsGroupsTour';
import { tourName as AccountsUsersTour } from './config/accountsUsersTour';
import { tourName as HomePageTour } from './config/homePageTour';
import { tourName as PlatformUsageTour } from './config/platformUsageTour';

// Workers

export function* checkOnboardingWorker() {
  const auth = yield select(getAuth);
  const visits = yield call(getVisits, auth);

  yield put(startOnboarding(Object.keys(visits).length === 0));
}

/**
 * Setup and start multi-page tour.
 */
export function* stateMultiPageTourWorker(action) {
  try {
    let tourQueue = [];

    tourQueue.push(HomePageTour);

    if (yield select(hasAnalyticsPermission)) {
      tourQueue.push(PlatformUsageTour);
    }

    if (yield select(hasAccountsUsersAndGroupsPermission)) {
      tourQueue.push(AccountsUsersTour);
      tourQueue.push(AccountsGroupsTour);
    }

    tourQueue.push(CompletedTour);

    logEvent(ONBOARDING, START, action.referrer);
    yield put(startTour({ tourQueue }));
  } catch (err) {
    yield pushFormattedError(err);
  }
}

export function* endTourWorker(action) {
  logEvent(ONBOARDING, action.introJsAction, action.step);
  const auth = yield select(getAuth);
  yield call(markAsVisited, auth, 'home');
}

// Watcher
export function* runOnboardingSaga() {
  yield all([
    takeLatest(CHECK_ONBOARDING, checkOnboardingWorker),
    takeLatest(START_MULTI_PAGE_TOUR, stateMultiPageTourWorker),
    takeLatest(END_TOUR, endTourWorker),
    takeLatest(SKIP_TOUR, endTourWorker)
  ]);
}



// WEBPACK FOOTER //
// ./src/actions/onboarding/onboardingSagas.js